import { render, staticRenderFns } from "./createCollection.vue?vue&type=template&id=1263e651&scoped=true&"
import script from "./createCollection.vue?vue&type=script&lang=js&"
export * from "./createCollection.vue?vue&type=script&lang=js&"
import style0 from "./createCollection.vue?vue&type=style&index=0&id=1263e651&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1263e651",
  null
  
)

export default component.exports